import { useQuery } from "@apollo/client";
import { gql } from "@apollo/client";

import { addAuthVars } from "@teamrota/authlib";

const GET_LAST_USED_UNIFORM_AND_BRIEFING = addAuthVars(gql`
  query getLastUsedUniformAndBriefing($venueId: ID, $roleRateId: ID) {
    user {
      id
      lastUsedBriefingTemplate(venueId: $venueId, roleRateId: $roleRateId) {
        id
        identifier
        content
      }
      lastUsedUniformTemplate(venueId: $venueId, roleRateId: $roleRateId) {
        id
        identifier
      }
    }
  }
`);

const useGetLastUsedUniformAndBriefing = values => {
  const { data, loading, error, refetch } = useQuery(
    GET_LAST_USED_UNIFORM_AND_BRIEFING,
    {
      fetchPolicy: "cache-and-network",
      variables: {
        roleRateId: values.roleRateId,
        venueId: values.venueId,
        connectionLimit: 0,
        connectionOffset: 0
      }
    }
  );

  return {
    lastUsedUniform: data?.user?.lastUsedUniformTemplate?.[0] || {},
    lastUsedBriefing: data?.user?.lastUsedBriefingTemplate?.[0] || {},
    isLoadingLastUsedUniformAndBriefing: loading,
    errorLoadingLastUsedUniformAndBriefing: error,
    refetchLastUsedUniformAndBriefing: refetch
  };
};

export default useGetLastUsedUniformAndBriefing;
